'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonToDateWithDaysUntil = undefined;
var _jsonToDate = require('./json-to-date');
var _jsonToDate2 = _interopRequireDefault(_jsonToDate);
var _start_of_day = require('date-fns/start_of_day');
var _start_of_day2 = _interopRequireDefault(_start_of_day);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var jsonToDateWithDaysUntil = exports.jsonToDateWithDaysUntil = function jsonToDateWithDaysUntil(d) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var withTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var nOfDaysUntil = Math.ceil((new Date(d.year, d.month - 1, d.day, 0, 0, 0) - (0, _start_of_day2.default)(now)) / (1000 * 60 * 60 * 24));
  switch (nOfDaysUntil) {
    case 0:
      return (0, _jsonToDate2.default)(d, withTime) + ' (Today)';
    default:
      return (0, _jsonToDate2.default)(d, withTime) + ' ' + (Math.abs(nOfDaysUntil) === 1 ? '(' + (nOfDaysUntil < 0 ? '' : 'In ') + Math.abs(nOfDaysUntil) + ' Day' + (nOfDaysUntil < 0 ? ' Ago' : '') + ')' : '(' + (nOfDaysUntil < 0 ? '' : 'In ') + Math.abs(nOfDaysUntil) + ' Days' + (nOfDaysUntil < 0 ? ' Ago' : '') + ')');
  }
};
exports.default = jsonToDateWithDaysUntil;